module.exports = __webpack_public_path__ + "assets/img/Playbook.0cf402ee.png";